import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBody } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { MaterialMaster } from '../../TitleList';
import { fetchMatStockData } from '../../../Store/PHPSlice/MatStock';


const MatStockTable = () => {
    const dispatch = useDispatch();
    const materials = useSelector((state) => state.MatStockData.matStock || { data: [] });
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    // console.log(materials)
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchMatStockData());
    }, [dispatch]);

    if (!materials) {
        return <h1>Loading...</h1>;
    }


    const compData = Array.isArray(materials?.data || materials)
        ? (materials.data).map((item, index) => ({
            srno: item.ID,
            barcode: item.barcode,
            materialNm: item.materialNm,
            matId: item.matId,
            size: item.size,
            mqty: item.mqty,
            mtype: item.mtype,
            perpktqty: item.perpktqty,
            ptype: item.ptype,
            locationId: item.locationId,
            locNm: item.locNm,
            firmId: item.firmId,
            firmNm: item.firmNm,
            actpqty: item.actpqty,
            balpqty: item.balpqty,
            actmtr: item.actmtr,
            balmtr: item.balmtr,
            actInch: item.actInch,
            balInch: item.balInch,
            actTotqty: item.actTotqty,
            balTotqty: item.balTotqty,
            spqty: (Number(item.spqty)).toFixed(2),
            smtr: (Number(item.smtr)).toFixed(2),
            sInch: (Number(item.sInch)).toFixed(2),
            sTotqty: (Number(item.sTotqty)).toFixed(2),
            serialNumber: index + 1
        }))
        : [];

    // console.log("compdata=>", compData);


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = [...Array(npages + 1).keys()].slice(1);
    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 5);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n - 1 ? 'active' : ''}`} onClick={() => handleChangeCPage(n - 1)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);


    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });
    // const notFound = !dataFiltered.length;

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        (item?.firmNm || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.locNm || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.materialNm || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.size || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.mtype || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.ptype || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.barcode || '').toLowerCase().includes(searchTerm.toLowerCase())
    );



    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>
            <Titlebar data={MaterialMaster} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Stock Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                // { id: 'firmNm', label: 'Firm' },
                                                { id: 'locNm', label: 'Location' },
                                                { id: 'barcode', label: 'Barcode' },
                                                { id: 'materialNm', label: 'Material' },
                                                { id: 'size', label: 'Size' },
                                                { id: 'mtype', label: 'M.Qty' },
                                                { id: 'ptype', label: 'P.P Qty' },
                                                { id: 'actpqty', label: 'Stock P. Qty' },
                                                { id: 'spqty', label: 'Sale P. Qty' },
                                                { id: 'bpqty', label: 'Balance P. Qty' },
                                                { id: 'actmtr', label: 'Stock Mtr.' },
                                                { id: 'smtr', label: 'Sale Mtr.' },
                                                { id: 'balmtr', label: 'Balance Mtr.' },
                                                { id: 'actInch', label: 'Stock Inch' },
                                                { id: 'sInch', label: 'Sale Inch' },
                                                { id: 'balInch', label: 'Balance Inch' },
                                                { id: 'actTotqty', label: 'Stock Total Qty.' },
                                                { id: 'sTotqty', label: 'Sale Total Qty.' },
                                                { id: 'balTotqty', label: 'Balance Total Qty.' },
                                                { id: '', label: 'View' }
                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row) => (
                                            <TableBody
                                                key={row.matId}
                                                id={row.srno}
                                                barcode={row.barcode}
                                                materialNm={row.materialNm}
                                                matId={row.matId}
                                                size={row.size}
                                                mqty={row.mqty}
                                                mtype={row.mtype}
                                                perpktqty={row.perpktqty}
                                                ptype={row.ptype}
                                                locationId={row.locationId}
                                                locNm={row.locNm}
                                                firmId={row.firmId}
                                                firmNm={row.firmNm}
                                                actpqty={row.actpqty}
                                                balpqty={row.balpqty}
                                                actmtr={row.actmtr}
                                                balmtr={row.balmtr}
                                                actInch={row.actInch}
                                                balInch={row.balInch}
                                                actTotqty={row.actTotqty}
                                                balTotqty={row.balTotqty}
                                                spqty={row.spqty}
                                                smtr={row.smtr}
                                                sInch={row.sInch}
                                                sTotqty={row.sTotqty}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />

                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default MatStockTable;
